<template>
  <b-row align-v="center" align-h="center" class="h-100">
    <h1>Página não encontrada.</h1>
  </b-row>
</template>

<script>
export default {};
</script>

<style>
</style>